var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeBuild.cpu)?_c('compatibility-features',{attrs:{"active-build":_vm.activeBuild,"div-class":"compatibility-list"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }